import type { ReactElement } from 'react';
import { Root } from './root.jsx';
import type { PlaceholderProps } from './types.js';

/** `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => <Root {...props} />;
